import React from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as IconEyeOff } from '@pkg/assets/icons/v2/eye-off.svg';
import { ADMIN_TYPE_ADMIN, ADMIN_TYPE_EVERYONE } from '@pkg/components/Sections/Groups';
import { InputRadio, type InputRadioGroupProps } from '@pkg/components/Sections/Profile/Inputs';
import { ReactComponent as IconLockClosed } from '@pkg/components/Sections/Profile/icons/lock-closed.svg';
import { ReactComponent as IconLockOpen } from '@pkg/components/Sections/Profile/icons/lock-open.svg';
import { useMediaQuery } from '@pkg/providers';

import { GroupPrivacyTypes } from '@app/client/common/structs/groups/social-groups';
import { GlobeIcon } from '@app/pages/Prototype/components/Profile/components/SocialLinks/icons';

const PRIVACY_GROUP_NAME = 'PrivacySetting';
const PERMISSIONS_GROUP_NAME = 'PermissionsSetting';

export function useSettingsContent() {
    const { t: translate } = useTranslation('groups');
    const { tablet } = useMediaQuery();

    const privacyItems: InputRadioGroupProps['items'] = [
        {
            id: 'Pods-PrivacySetting-Public',
            value: GroupPrivacyTypes.Public,
            icon: <GlobeIcon />,
            label: translate('pods_settings_privacy_public_label'),
            infoText: tablet ? undefined : translate('pods_settings_privacy_public_info'),
            tooltip: tablet ? (
                <InputRadio.Tooltip
                    title={translate('pods_settings_privacy_public_tooltip_title')}
                    description={translate('pods_settings_privacy_public_info')}
                />
            ) : undefined,
        },
        {
            id: 'Pods-PrivacySetting-Private',
            value: GroupPrivacyTypes.Private,
            icon: <IconEyeOff />,
            label: translate('pods_settings_privacy_private_label'),
            infoText: tablet ? undefined : translate('pods_settings_privacy_private_info'),
            tooltip: tablet ? (
                <InputRadio.Tooltip
                    title={translate('pods_settings_privacy_private_tooltip_title')}
                    description={translate('pods_settings_privacy_private_info')}
                />
            ) : undefined,
        },
    ];

    const permissionsGroup: InputRadioGroupProps['items'] = [
        {
            id: 'Pods-PermissionsSetting-Owner',
            value: ADMIN_TYPE_ADMIN,
            icon: <IconLockClosed />,
            label: translate('pods_settings_permissions_owner_label'),
            infoText: tablet ? undefined : translate('pods_settings_permissions_owner_info'),
            tooltip: tablet ? (
                <InputRadio.Tooltip
                    title={translate('pods_settings_permissions_owner_label')}
                    description={translate('pods_settings_permissions_owner_info')}
                />
            ) : undefined,
        },
        {
            id: 'Pods-PermissionsSetting-Private',
            value: ADMIN_TYPE_EVERYONE,
            icon: <IconLockOpen />,
            label: translate('pods_settings_permissions_everyone_label'),
            infoText: tablet ? undefined : translate('pods_settings_permissions_everyone_info'),
            tooltip: tablet ? (
                <InputRadio.Tooltip
                    title={translate('pods_settings_permissions_everyone_label')}
                    description={translate('pods_settings_permissions_everyone_info')}
                />
            ) : undefined,
        },
    ];

    return {
        privacy: {
            id: PRIVACY_GROUP_NAME,
            title: translate('pods_settings_privacy_title'),
            items: privacyItems,
        },
        permissions: {
            id: PERMISSIONS_GROUP_NAME,
            title: translate('pods_settings_permissions_title'),
            items: permissionsGroup,
        },
    };
}
